import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './device-configured-applications.reducer';
import { ConfiguredApplication, DeviceConfiguredApplicationsState } from './device-configured-applications.state';

export const selectDeviceConfiguredApplicationsState = createFeatureSelector<DeviceConfiguredApplicationsState>(
  'device-configured-applications'
);

export const selectDeviceConfiguredApplicationsIds = createSelector(
  selectDeviceConfiguredApplicationsState,
  fromReducer.selectDeviceConfiguredApplicationsIds
);

export const selectDeviceConfiguredApplicationsEntities = createSelector(
  selectDeviceConfiguredApplicationsState,
  fromReducer.selectDeviceConfiguredApplicationsEntities
);

export const selectDeviceConfiguredApplications = createSelector(
  selectDeviceConfiguredApplicationsState,
  fromReducer.selectDeviceConfiguredApplications
);

export const selectDeviceConfiguredApplicationsByUdid = (udid: string) =>
  createSelector(
    selectDeviceConfiguredApplications,
    (configuredApplications: ConfiguredApplication[]): ConfiguredApplication[] => {
      return configuredApplications.filter((x) => x.deviceId === udid);
    }
  );
